/**
 * The disclosure chevron shared by the Connected apps groups and the Activity
 * "Details" toggle. Points right when collapsed; the rotation is CSS keyed on
 * the control's open state (aria-expanded / details[open]), so the icon can
 * never disagree with it. Decorative: the control's text names it.
 */
export default function Chevron({ className = '' }) {
  return (
    <svg className={`pf-chevron ${className}`.trim()} width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="m9 6 6 6-6 6" />
    </svg>
  );
}
